import { AfterContentChecked, Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'lib-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.css']
})
export class UploadFileComponent implements AfterContentChecked, OnChanges {
  @ViewChild('fileInput') fileInput!: ElementRef;
  files: any;
  fileUploadDoc: any = {};
  baseUrl: string = '';
  @Input() documentInfo: any;
  @Input() fileUploadConfig: any;
  @Input() resetFileUpload: boolean = false;
  @Output() fileUploadEvent = new EventEmitter<any>();
  fileFormats: string = '';
  
  fileUploadForm!: FormGroup;
  loader: boolean = false;
  constructor(
    private toastr: ToastrService,
    private http: HttpClient
  ) {}

  fileSizeConvert(b: number) {
    let u = 0, s=1024;
    while (b >= s || -b >= s) {
      b /= s;
      u++;
    }
    return (u ? b.toFixed(1) + ' ' : b) + ' KMGTPEZY'[u] + 'B';
  }

  ngOnChanges(changes: SimpleChanges): void {
    let resetChange = changes['resetFileUpload'];
    if (resetChange && resetChange.currentValue) {
      this.files = [];
    }
  }

  ngAfterContentChecked(): void {
    this.baseUrl = this.documentInfo.baseUrl;
    this.createUploadFileForm();
    this.fileFormats = this.fileUploadConfig.fileFormats;
  }

  createUploadFileForm(): void {
    this.fileUploadForm = new FormGroup({
      fileUpload: new FormControl(undefined)
    });
  }
 
  getFileUploadS3UrlAndUpload() {
    const fileNameList = this.files[0]?.name?.split('.');
    const filesData = {
      fileName: this.files[0].name,
      type: this.files[0].type,
      size: this.fileSizeConvert(this.files[0].size),
      userType: this.documentInfo.userType,
      location: `${this.documentInfo.userType}/${this.documentInfo.documentUseFor}/${fileNameList[0]}-${this.files[0].lastModified}.${fileNameList[1]}`,
      documentUseFor: this.documentInfo.documentUseFor
    }
    this.http.post(`${this.baseUrl}auth-service/uploadDocuments`, filesData).subscribe({
      next: (data: any) => {
        this.fileUploadDoc = data.response;
        this.awsBasicUploadSingle(data.response.presignedUrl);
      },
      error: (error: HttpErrorResponse) => {
        this.toastr.error(error.error.status.error.message);
      }
    });
  }

  awsBasicUploadSingle(url: string) {
    const HttpUploadOptions = {
      headers: new HttpHeaders({ "Content-Type": this.files[0].type})
    }
    this.loader = true;
    this.http.put(url, this.files[0], HttpUploadOptions).subscribe({
      next: (data: any) => {
        this.loader = false;
        this.fileUploadDoc.fileUploadStatus = true;
        this.fileUploadEvent.emit(this.fileUploadDoc);
      },
      error: (error: HttpErrorResponse) => {
        this.loader = false;
        this.fileUploadDoc.fileUploadStatus = false;
        this.toastr.error(error.error.status.error.message);
      }
    });
  }

  deleteAttachedFile(): void {
    if (this.files.length) {
      this.fileInput.nativeElement.value = "";
      this.fileUploadEvent.emit({});
      this.files = [];
    }
  }

  downloadAttachedFile(): void {
    if (this.files.length) {
      let link = document?.createElement('a');
      link.href = window.URL.createObjectURL(this.files[0]);
      link.download = this.files[0].name;
      link.target = '_blank';
      link.click();
    }
  }
 
  prepareFilesList(files: any): void {
    if (files.target.files[0].size > this.fileUploadConfig.fileSizeLimit) {
      this.toastr.error(`File size exceeds ${this.fileSizeConvert(this.fileUploadConfig.fileSizeLimit)}`);
      return;
    }
    this.files = files.target.files;
    this.getFileUploadS3UrlAndUpload();
  }
}
